import { Controller } from 'react-hook-form';
import { CurrencyInput, FormField, InputV2 } from '@which/seatbelt';
import { jsx as _jsx } from "react/jsx-runtime";
export const ControlledTextField = _ref => {
  let {
    className,
    control,
    errorMsg,
    inputType = 'text',
    placeholder,
    label,
    name,
    required = true,
    showRequiredText = true,
    tooltip,
    validation,
    ...rest
  } = _ref;
  const rules = inputType === 'currency' ? validation || {
    required,
    pattern: /(?=.*?\d)(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/ // up to 2 decimal places
  } : validation || {
    required
  };
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    defaultValue: "",
    name: name,
    render: _ref2 => {
      let {
        field: {
          onChange,
          onBlur,
          value,
          ref
        },
        fieldState: {
          error
        }
      } = _ref2;
      return /*#__PURE__*/_jsx(FormField, {
        className: className,
        label: label,
        labelFor: name,
        required: required,
        showRequiredText: showRequiredText,
        tooltip: tooltip,
        ...(error && {
          errorMsg
        }),
        children: inputType === 'currency' ? /*#__PURE__*/_jsx(CurrencyInput, {
          "aria-invalid": !!error,
          inputMode: "decimal",
          inputRef: ref,
          name: name,
          onBlur: onBlur,
          onChange: onChange,
          value: value,
          ...rest
        }) : /*#__PURE__*/_jsx(InputV2, {
          "aria-invalid": !!error,
          inputRef: ref,
          name: name,
          onBlur: onBlur,
          onChange: onChange,
          placeholder: placeholder,
          type: inputType,
          value: value,
          ...rest
        })
      });
    },
    rules: rules
  });
};

///////// IMPLEMENTATION /////////